import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import "./v-descriptive-list-item.component.scss";


@Component({
    selector: "v-descriptive-list-item",
    template: require("./v-descriptive-list-item.component.html")
})
export class VDescriptiveListItemComponent implements AfterViewInit {

    @Input() title: string;
    @Input() description: string;

    @Input() @HostBinding("class.clickable") clickable: boolean;

    @ViewChild('titleStartContainer', { static: true }) titleStartContainer: ElementRef;
    @ViewChild('titleEndContainer', { static: true }) titleEndContainer: ElementRef;
    @ViewChild('titleContainer', { static: true }) titleContainer: ElementRef;
    @ViewChild('descriptionContainer', { static: true }) descriptionContainer: ElementRef;

    constructor() {}

    ngAfterViewInit(): void {
        this.removeElementsIfEmpty();
    }

    // ---

    private removeElementsIfEmpty(): void {
        if (!this.titleStartContainer?.nativeElement?.innerHTML) {
            this.titleStartContainer.nativeElement.remove();
        }

        if (!this.titleEndContainer?.nativeElement?.innerHTML) {
            this.titleEndContainer.nativeElement.remove();
        }

        if (!this.titleContainer?.nativeElement?.innerHTML) {
            this.titleContainer.nativeElement.remove();
        }

        if (!this.descriptionContainer?.nativeElement?.innerHTML) {
            this.descriptionContainer.nativeElement.remove();
        }
    }
}
